import axios from "axios";
import { clearLocalStorageData, getLocalStorageData } from "../shared/commonFunction";
import { showToast } from "../shared/sharedComponents/ToasterMessage/ToasterMessage";

export const getApiRequest = async (END_POINTS) => {
    const BASE_URL = import.meta.env.VITE_API_URL;
    const API_KEY = import.meta.env.VITE_API_KEY
    const token = getLocalStorageData("token");
    const selectedLanguage = getLocalStorageData("language") || "ar";


    try {
        const response = await axios.get(`${BASE_URL}/${END_POINTS}`, {
            headers: {
                Authorization: `Bearer ${token}`,
                "Accept-Language": selectedLanguage,
                "X-API-Key": API_KEY

            },
        });
        return response?.data;
    } catch (error) {
        if (error?.response?.status === 401) {
            showToast(error.response.data.message, 'error');
            clearLocalStorageData();
            window.location.href = "/login";
        } else if (error?.response?.status === 400) {
            showToast(error.response.data.message, 'error');
        }
        throw error;
    }
};
